import React from 'react';

const Contact = () => {
  return (
    <div className='mx-2' id='contact'>
        <h1 className='section-header  mt-5'>Contact us</h1>
        <p className='text-start'>For all inquiries, contact us at <a href='mailto:info@drbellys.com'>info@drbellys.com</a></p>
    </div>
  );
};

export default Contact;